module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAQFJREFUSInVlUuygjAQRU8st5BKdvOalYkrA3fDq15EHIABNZAEceAd8UnuodMf4Ndlljfq6ACp9Ogx3OxAm3p5juaeloAAfSVACIh6WIOMAEenjlBpHj9OHUH9lwBb+097DVdB/jmHRYDXTUkZbqnHWYB6hDCGv3nGK8pHELgsr6dSPhDwkKFhLGFRR1d0bDUAO9DbfxoMV8ZmPBbwpsBfybJzfsksdXRTtzNFchwgNpHhujkSXpQ/omV9V5pDQQR2oFVPb4fqIQgUJnmveTHgE9VV0dxcMpWpYGi2IlwFRLN5VEhimGdz8waIv82EGRDrvzQvqQhkr1l2bekAq9l/B1YHXwu1NLY9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/icon2ed.png
// module id = Ag7G
// module chunks = 1